<script>
export default {
  name: 'BasePrice',

  props: {
    shopifyData: {
      type: Object,
      default: () => {}
    },
    selectedVariantWithVaryingPrice: {
      type: Object,
      default: null
    }
  },

  computed: {
    hasProductData () {
      return this.shopifyData && Object.keys(this.shopifyData).length > 0
    },

    isOnSale () {
      if (this.selectedVariantWithVaryingPrice) {
        return this.selectedVariantWithVaryingPrice.compare_at_price > this.selectedVariantWithVaryingPrice.price
      }
      return this.hasProductData && this.shopifyData.product.compare_at_price > this.shopifyData.product.price
    },

    defaultPrice () {
      if (this.selectedVariantWithVaryingPrice) {
        return this.$filters.shopifyMoney(this.selectedVariantWithVaryingPrice.price)
      }
      return this.hasProductData ? this.$filters.shopifyMoney(this.shopifyData.product.price) : null
    },

    compareAtPrice () {
      if (this.selectedVariantWithVaryingPrice) {
        return this.$filters.shopifyMoney(this.selectedVariantWithVaryingPrice.compare_at_price)
      }
      return this.hasProductData ? this.$filters.shopifyMoney(this.shopifyData.product.compare_at_price) : null
    }
  }
}
</script>

<template>
  <div
    class="price t-label"
    aria-live="polite"
  >
    <slot />
    
    <template v-if="hasProductData">
      <template v-if="shopifyData.product.available">
        <template v-if="isOnSale">
          <span class="price__item price__item--regular">
            <span class="visually-hidden">{{
              window.theme.language.products.product.price.regularPrice
            }}</span>
            <span>
              <s>{{ compareAtPrice }}</s>
            </span>
          </span>

          <span class="price__item price__item--sale">
            <span class="visually-hidden">{{
              window.theme.language.products.product.price.salePrice
            }}</span>
            <span>{{
              defaultPrice
            }}</span>
          </span>
        </template>

        <template v-else>
          <span class="visually-hidden">{{
            window.theme.language.products.product.price.unitPrice
          }}</span>
          <span class="price__item">{{
            defaultPrice
          }}</span>
        </template>
      </template>

      <!-- sold out -->
      <span
        v-else
        class="price__item price__item--sold-out"
      >{{
        window.theme.language.products.product.soldOut
      }}</span>
    </template>
  </div>
</template>
